export const VALIDATION_PATTERNS = {
    PHONE: "^\\d{3}\\s?\\d{3}\\s?\\d{4}$",
    PASSWORD: "^(?=.*[A-Za-z])(?=.*\\d)(?=.*[^A-Za-z\\d])[A-Za-z\\d\\W_]{8,}$",
    TEXT_SANITIZE: "[^A-Za-zÀ-ÿ0-9\\s'.-]",
    TEL_SANITIZE: "[^\\d\\s]"
} as const;

export const VALIDATION_MESSAGES = {
    PHONE: "Please enter a valid phone number.",
    PASSWORD: "Password must contain 8 characters and include letters, numbers, and symbols."
} as const;

export const formatPhoneNumber = (input: string): string => {
    // Remove all non-digit characters
    const digitsOnly = input.replace(/\D/g, '');
    
    // Format as XXX XXX XXXX for display
    if (digitsOnly.length >= 10) {
        return digitsOnly.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
    }
    return digitsOnly;
};

export const stripPhoneNumber = (phone: string): string => {
    return phone.replace(/\s/g, '');
};

export const isAlphanumericOrSpace = (str: string): boolean => {
    // This pattern allows:
    // - Basic Latin letters (A-Z, a-z)
    // - Accented characters (á, é, í, ñ, ó, ú, ü, etc.)
    // - Numbers (0-9)
    // - Spaces
    // - Common name characters:
    //   - Apostrophe (O'Connor, D'Angelo)
    //   - Hyphen (Jean-Pierre, Smith-Jones)
    //   - Period (St. John, J.R.)
    return /^[A-Za-zÀ-ÿ0-9\s'.-]*$/.test(str);
};

export const isNumericOnly = (str: string): boolean => {
    return /^\d*$/.test(str);
};

export const sanitizeText = (value: string): string => {
    return value.replace(new RegExp(VALIDATION_PATTERNS.TEXT_SANITIZE, 'g'), '');
};

export const sanitizeTel = (value: string): string => {
    const cleaned = value.replace(new RegExp(VALIDATION_PATTERNS.TEL_SANITIZE, 'g'), '');
    return formatPhoneNumber(cleaned);
};